import './full-slider.scss'
import { tweenSlideOut, tweenSlideIn } from './full-slider-tweens.js'
import { loadImage } from 'js/utility/image.js'

export const component = {
    name: 'full-slider',

    data: {
        id: null,
        index: 0,
        interactions: true,
        slides: [],
        slideTimeout: null,
        dateStart: null,
        dateEnd: null,
        dateRange: null,
        location: null,
        people: 1,
        children: 0,
        rooms: 1,
        overlayImageSrc: null,
        slideContent: true
    },

    computed: {
        currentSlide () {
            if (this.slides[this.index]) {
                return this.slides[this.index]
            } else {
                return null
            }
        },

        showPrev () {
            return this.index > 0
        },

        showNext () {
            return this.index < (this.slides.length - 1)
        }
    },

    watch: {
        dateStart(value) {
            if (this.dateEnd === null) {
                this.dateEnd = value
            }
        },

        dateEnd(value) {
            if (value && this.dateStart) {
                if (value < this.dateStart) {
                    this.dateEnd = null
                }
            }
        }
    },

    mounted () {
        this.slideContent = !!(this.currentSlide && this.currentSlide.title)
        this.setSlideTimeout()
    },

    methods: {
        setSlideTimeout () {
            clearTimeout(this.slideTimeout)
            this.slideTimeout = setTimeout(() => {
                let nextIndex = (this.index + 1 === this.slides.length) ? 0 : this.index + 1
                this.toggleSlide(nextIndex)
            }, 10000)
        },

        toggleNextSlide () {
            const nextIndex = this.index + 1
            if (nextIndex === this.slides.length) {
                return
            } else {
                this.toggleSlide(nextIndex)
            }
        },

        togglePrevSlide () {
            const nextIndex = this.index - 1
            if (nextIndex < 0) {
                return
            } else {
                this.toggleSlide(nextIndex)
            }
        },

        toggleSlide(i) {
            if (i === this.index) {
                return
            }

            if (!this.interactions) {
                return
            }

            if (!this.slides[i]) {
                return
            }

            clearTimeout(this.slideTimeout)
            this.interactions = false

            const onTransitionEnd = function() {
                this.index = i
                this.overlayImageSrc = null
                this.interactions = true
                this.$refs.backgroundOverlay.removeEventListener('transitionend', onTransitionEnd)
            }.bind(this)

            Promise.resolve()
                .then(() => loadImage(this.slides[i].image.sizes.wide))
                .then(img => {
                    this.slideContent = !!this.slides[i].title
                    this.overlayImageSrc = img.src
                    this.$refs.backgroundOverlay.addEventListener('transitionend', onTransitionEnd)
                })
        },

        __toggleSlide (i) {
            if (i === this.index) {
                return
            }

            if (!this.interactions) {
                return
            }

            clearTimeout(this.slideTimeout)
            this.interactions = false

            Promise.resolve()
                .then(() => Promise.all([tweenSlideOut.call(this), loadImage(this.slides[i].image.sizes.wide)]))
                .then(() => {
                    this.index = i
                })
                .then(() => tweenSlideIn.call(this))
                .then(() => {
                    this.interactions = true
                    this.setSlideTimeout()
                })
        },

        submit () {
            if (!(this.dateStart && this.dateEnd)) {
                return
            }

            let from = this.dateStart
            let to = this.dateEnd

            if (!from) {
                return
            } else {
                from = `${from.getDate()}-${from.getMonth() + 1}-${from.getFullYear()}`
            }

            if (!to) {
                return
            } else {
                to = `${to.getDate()}-${to.getMonth() + 1}-${to.getFullYear()}`
            }

            let url = null
            if (this.location) {
                const location = _.find(this.locations, location => location.booking_id === this.location)
                const locationBooking = location.booking
                const locationBookingId = location.booking_id // same as this.location

                if (locationBooking === 'fullboard') {
                    url = `http://${location.booking_account_name}.fullboard.cloud/booking/prenota-hotel/${locationBookingId}_struttura.html?checkFilter=true&data_checkin=${from}&data_checkout=${to}&n_camere=1&room_number=1&n_adulti=${this.people}&n_bambini=${this.children}&trattamento=struttura`
                } else {
                    from = from.split('-')
                    from[0] = (from[0].length === 1) ? '0' + from[0] : from[0]
                    from[1] = (from[1].length === 1) ? '0' + from[1] : from[1]
                    from = `${from[2]}-${from[1]}-${from[0]}`

                    to = to.split('-')
                    to[0] = (to[0].length === 1) ? '0' + to[0] : to[0]
                    to[1] = (to[1].length === 1) ? '0' + to[1] : to[1]
                    to = `${to[2]}-${to[1]}-${to[0]}`

                    url = `https://secure.kosmosol.it/booking/v2/check-availability.php?h=${locationBookingId}&l=${this.currentLanguage}&bd=${from}&ed=${to}`
                }
                window.open(url, '_blank')
            } else {
                // url = `http://bookingromaresort.fullboard.cloud/booking/prenota-ora.html?checkFilter=true&data_checkin=${from}&data_checkout=${to}&n_camere=1&n_adulti=${this.people}&n_bambini=${this.children}`
            }

        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/full-slider/full-slider.js